import { createContext } from "react";

export type UserRole = "creator" | "student";

export type UserRoleContextType = {
  userRole: UserRole;
  setUserRole: (role: UserRole) => void;
};

export const UserRoleContext = createContext<UserRoleContextType | undefined>(undefined);

